import {DECODE_VIN_DATA} from './actions';

const initialState = {
    errorCMsg:{},
    decodedVinVehicleObject:{},

};



export default function reducer(state = initialState, action) {
  switch (action.type) {
      case DECODE_VIN_DATA:
          return Object.assign({}, state, {
              decodedVinVehicleObject: action.decodedVinData
          });
    default:
      return state;
  }
}
